var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.payfactoSupport)?_c('a',{staticClass:"support-btn",attrs:{"href":_vm.payfactoSupport.url[_vm.$ts.state.locale],"target":"_blank"}},[(_vm.dot)?_c('div',{staticClass:"dot"}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('payfacto_support.' + _vm.payfactoSupport.type))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }